"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _style = require("./style");

var Button = function Button(_ref) {
  var children = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      handleClick = _ref.handleClick,
      id = _ref.id,
      name = _ref.name,
      reverse = _ref.reverse,
      text = _ref.text,
      width = _ref.width,
      height = _ref.height,
      margin = _ref.margin,
      type = _ref.type;
  return _react["default"].createElement(_style.ButtonStyled, {
    className: className,
    disabled: disabled,
    id: id,
    name: name,
    onClick: handleClick,
    reverse: reverse,
    type: type,
    width: width,
    height: height,
    margin: margin
  }, children || text);
};

Button.propTypes = {
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  handleClick: _propTypes["default"].func.isRequired,
  id: _propTypes["default"].string,
  name: _propTypes["default"].string,
  reverse: _propTypes["default"].bool,
  text: _propTypes["default"].string,
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  margin: _propTypes["default"].string,
  type: _propTypes["default"].string
};
Button.defaultProps = {
  className: '',
  children: undefined,
  disabled: false,
  id: 'button',
  name: 'button',
  reverse: false,
  text: "I'm a button",
  width: undefined,
  height: undefined,
  margin: undefined,
  type: 'button'
};
var _default = Button;
exports["default"] = _default;